module.exports = __webpack_public_path__ + "img/card2.f3952a1e.png";